// Dependencies
import React from 'react';
import uuid from 'react-uuid';

// Components
import Container from '../../container/container';
import Image from '../../image/image';
import Slider from '../../slider/slider';

// Hooks
import useFeaturedAwards from '../../../hooks/useFeaturedAwards';
import useAwardsSliderOptions from '../../../hooks/useAwardsSliderOptions';

// Styles
import AwardsSliderStyles from './awardsSlider.styles';

export default function AwardsSlider() {
  const featuredAwards = useFeaturedAwards();

  const options = useAwardsSliderOptions();
  const heading = options?.awardsSliderHeading;

  return (
    <AwardsSliderStyles>
      <Container>
        <h2 className="heading">{heading}</h2>
      </Container>
      <div className="wrapper">
        <Container fullWidth>
          <Slider
            slides={2}
            gap={2}
            autoscroll
            interactable={false}
            breakpoints={{
              375: { slides: 2, gap: 2 },
              768: { slides: 3, gap: 2 },
              992: { slides: 3, gap: 3 },
              1200: { slides: 6, gap: 3.75 },
              1920: { slides: 8, gap: 6.25 },
            }}
          >
            {featuredAwards.map((award) => (
              <div key={uuid()}>
                <Image
                  image={award?.featuredImage?.node}
                  filter={false}
                  loading="eager"
                />
              </div>
            ))}
          </Slider>
        </Container>
      </div>
    </AwardsSliderStyles>
  );
}
